import { KeyValue, NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { FormModule } from '@coreui/angular';
import { IFloatingFilterAngularComp } from 'ag-grid-angular';
import { IFloatingFilterParams, ISimpleFilter } from 'ag-grid-community';

export interface CustomParams {
  filterList: KeyValue<string, string>[];
}

@Component({
  selector: 'smarsh-aggrid-os-filter',
  standalone: true,
  imports: [FormModule, NgFor],
  templateUrl: './aggrid-custom-dropdown-filter.component.html',
  styles: `
    :host {
      width: 100%;
    }
    .ag-grid-filter-dropdown {
      height: 26px !important;
      font-size: 0.7rem !important;
      padding-bottom: 4px !important;
      padding-top: 4px !important;
      box-shadow: none !important;
    }
  `
})
export class AggridCustomDropdownFilterComponent
  implements IFloatingFilterAngularComp
{
  params!: IFloatingFilterParams & CustomParams;
  currentValue: string = '';
  filters: KeyValue<string, string>[];

  agInit(params: IFloatingFilterParams<ISimpleFilter> & CustomParams): void {
    this.params = params;
    this.filters = params.filterList;
  }

  onParentModelChanged(parentModel): void {
    if (!parentModel) {
      this.currentValue = '';
    } else {
      this.currentValue = parentModel.filter;
    }
  }

  onValueChanged(event) {
    this.currentValue = event.target.value;
    this.params.parentFilterInstance((instance) => {
      instance.onFloatingFilterChanged('equals', this.currentValue);
    });
  }
}
